import React, { useState } from "react";
import { Button, Modal, Tooltip } from "@mantine/core";
import { IconMessageCircleFilled } from "@tabler/icons-react";

import ProgressLine from "./ProgressLine";
import StarDisplay from "./StarDisplay";

const ListItem = ({
  comments = [],
  employeeCount = 0,
  employeeResponseCount = 0,
  rawResponses = [],
  responseTotal = 0,
  responseTotalMax = 0,
  text = "",
}) => {
  const [isOpen, setOpen] = useState(false);

  const percentage = (responseTotal / responseTotalMax) * 100;

  function onClose() {
    setOpen(false);
  }

  const breakdown = [
    { text: "Strongly Agree", value: 5 },
    { text: "Agree", value: 4 },
    { text: "Neutral", value: 3 },
    { text: "Disagree", value: 2 },
    { text: "Strongly Disagree", value: 1 },
  ].map((v) => ({
    key: v.value,
    star_count: v.value,
    text: v.text,
    count: rawResponses.filter((f) => f === v.value).length,
    percentage:
      (rawResponses.filter((f) => f === v.value).length / rawResponses.length) *
      100,
  }));

  return (
    <div className="list-item">
      {comments.length === 0 && <p>{text}</p>}
      {comments.length > 0 && (
        <button className="title" onClick={() => setOpen(true)}>
          <IconMessageCircleFilled size={16} title="Comments Available" />{" "}
          {text}
        </button>
      )}
      <Tooltip
        label={
          <div>
            <ResponseBreakdown items={breakdown} />
          </div>
        }
        withArrow
      >
        <div>
          <StarDisplay value={percentage} />
        </div>
      </Tooltip>
      {/* {percentage > 0 && <ProgressLine total={percentage} />} */}
      <Modal opened={isOpen} onClose={onClose} size="md" title={text}>
        <div className="comments">
          {comments.map((c, i) => (
            <p key={i}>{c}</p>
          ))}
        </div>
      </Modal>
      {/* <br />
      {responseTotal}/{responseTotalMax} response total
      <br />
      {employeeResponseCount}/{employeeCount} employees answered */}
    </div>
  );
};

export default ListItem;

function ResponseBreakdown({ items }) {
  return (
    <div className="response-breakdown">
      <ul>
        {items.map(({ key, star_count, text, count, percentage }) => (
          <li key={key}>
            <span className="answer-title">{text}</span>
            <span className="viz">
              <ProgressLine total={percentage} />
            </span>
            {/* <span className="stars">
              {[...Array(star_count)].map((e, i) => (
                <FaStar key={i} />
              ))}
            </span> */}
            <span className="count">{Math.round(percentage * 100) / 100}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

ResponseBreakdown.defaultProps = {
  stars: [],
};
